<div class="grid mt-2 ml-3  mr-3 overview-details">
    <div class="col-6 md:col-12 lg:col-6 pl-0">

        <div class="card p-fluid">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase" translate>DETAILS</label>
                </div>
                <div class="edit justify-content-center mb-3 cursor-pointer" [ngClass]="{'hidden': isDeleted}"
                    (click)="redirectToEdit()">
                    <label class="card-action" translate>site.lbl_edit</label>
                    <i class="mi-lg edit_pencil"></i>
                </div>
            </div>

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('site.fields.site_status.label',attributeLabels,'site_status')}}</label>
                </div>
                <div class="col-8  pb-1">
                    @for (item of attributeValues['site_status'] | keyvalue; track item.key) {
                    <span class="status-dot" [ngClass]="{
                                        'bg-green-500':item.value ?.toLowerCase() === 'active',
                                        'bg-red-500': item.value ?.toLowerCase() === 'inactive'
                                      }"></span> <label class="detail-value">{{ item.value }}</label>
                    }

                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('site.fields.site_code.label',attributeLabels,'site_code')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['site_code'] ? attributeValues['site_code'] : '--'
                        }}</label>
                </div>
            </div>

            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('site.fields.site_name.label',attributeLabels,'site_name')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['site_name'] ? attributeValues['site_name'] : '--'
                        }}</label>
                </div>
            </div>

            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>site.lbl_site_address</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">
                        {{ formatAddress() }}
                    </label>
                </div>
            </div>

            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>site.lbl_email</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">
                        {{ attributeValues['email'] ? attributeValues['email'] : '--' }}
                    </label>
                </div>
            </div>



        </div>
    </div>
</div>